<template>
  <div class="log">
    <Toast />
    <div class="header-log">
      <h1><span>MON</span>PERMIS.<span>FR</span></h1>
      <img src="../assets/images/logoMonPermis.png" alt="" />
    </div>

    <div class="access-gate" v-if="pageLocked">
      <div class="access-gate-card">
        <img src="../assets/images/logoMonPermis.png" alt="Logo MonPermis" class="access-gate-logo" />
        <h1>Accès restreint</h1>
        <p>
          Cette page est temporairement restreinte.<br />
          Si vous disposez d'un code d'accès, saisissez-le ci-dessous.
        </p>
        <input type="text" placeholder="Code d'accès" v-model="accessCode" />
      </div>
    </div>

    <template v-else>
    <div class="container" id="container">
      <!-- INSCRIPTION (desktop) -->
      <div class="form-container sign-up-container">
        <form @submit.prevent="inscription">
          <h1>Inscription</h1>
          <select v-model="motifInscription" required>
            <option value="" disabled selected>Motif de l'inscription</option>
            <option value="formation">Formation au permis</option>
            <option value="recuperer">Récupérer mon permis</option>
          </select>

          <template v-if="motifInscription === 'recuperer'">
            <p class="motif-redirect">
              monpermis.fr est un site de formation au permis de conduire.<br />
              Pour récupérer votre permis, rendez-vous sur
              <a href="https://permisdeconduire.ants.gouv.fr" target="_blank" rel="noopener">permisdeconduire.ants.gouv.fr</a>
            </p>
          </template>

          <template v-else>
            <input type="text" placeholder="Nom élève" v-model="form.nom" required />
            <input type="text" placeholder="Prénom élève" v-model="form.pnom" required />
            <input type="email" placeholder="Email" v-model="form.email" required />
            <input type="text" placeholder="Téléphone" v-model="form.tel" required />
            <div class="password-wrapper">
              <input
                :type="showInscPassword ? 'text' : 'password'"
                placeholder="Mot de passe"
                v-model="form.password"
                required
              />
              <button type="button" class="toggle-password" @click="showInscPassword = !showInscPassword">
                <i :class="showInscPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              </button>
            </div>
            <div class="password-wrapper">
              <input
                :type="showInscPasswordConfirm ? 'text' : 'password'"
                placeholder="Confirmer le mot de passe"
                v-model="form.passwordTest"
                required
              />
              <button type="button" class="toggle-password" @click="showInscPasswordConfirm = !showInscPasswordConfirm">
                <i :class="showInscPasswordConfirm ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              </button>
            </div>
            <select name="agence" id="agence" v-model="form.choixAgence" required>
              <option value="" disabled selected>
                Veuillez choisir votre agence
              </option>
              <option
                v-for="(agence, index) in agences"
                :value="agence.id"
                :key="index"
              >
                {{ agence.nom }}
              </option>
            </select>
            <button class="btn-action" v-if="isWorking === false">
              Inscription
            </button>
            <button v-else disabled>
              <span><i class="fa fa-spinner fa-spin"></i> Inscription </span>
            </button>
            <b-alert variant="danger" v-if="error != ''" show>{{
              error
            }}</b-alert>
          </template>
        </form>
      </div>

      <!-- CONNEXION (desktop) -->
      <div class="form-container sign-in-container">
        <form @submit.prevent="login">
          <h1>Connexion</h1>
          <input type="email" placeholder="Email" v-model="email" />
          <div class="password-wrapper">
            <input
              :type="showLoginPassword ? 'text' : 'password'"
              placeholder="Mot de passe"
              v-model="password"
            />
            <button type="button" class="toggle-password" @click="showLoginPassword = !showLoginPassword">
              <i :class="showLoginPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
            </button>
          </div>
          <a @click="this.displayMdpForm = true">Mot de passe oublié ?</a>
          <button v-if="isWorking === false" class="btn-action">
            Connexion
          </button>
          <button v-else disabled>
            <span><i class="fa fa-spinner fa-spin"></i> CONNEXION </span>
          </button>
          <b-alert variant="danger" v-if="error != ''" show>{{
            error
          }}</b-alert>
        </form>
      </div>

      <div class="overlay-container">
        <div class="overlay">
          <div class="overlay-panel overlay-left">
            <h1>Bon retour !</h1>
            <p>
              Pour vous connecter, veuillez saisir votre email et mot de passe
            </p>
            <button class="ghost btn-action" id="signIn" @click="showSignIn">
              connexion
            </button>
          </div>
          <div class="overlay-panel overlay-right">
            <h1>Bonjour !</h1>
            <p>
              Créez-vous un compte pour passer votre permis de conduire avec
              nous !
            </p>
            <button class="ghost btn-action" id="signUp" @click="showSignUp">
              inscription
            </button>
          </div>
        </div>
      </div>
    </div>

    <button
      class="mobile-button"
      v-if="showSignInMobile"
      @click="this.showSignInMobile = false"
    >
      CONNEXION
    </button>
    <button class="mobile-button" v-else @click="this.showSignInMobile = true">
      INSCRIPTION
    </button>

    <!-- MOBILE -->
    <div class="container-mobile">
      <!-- INSCRIPTION (mobile) -->
      <div class="insc" v-if="showSignInMobile">
        <form @submit.prevent="inscription">
          <h1>Inscription</h1>
          <select v-model="motifInscription" required>
            <option value="" disabled selected>Motif de l'inscription</option>
            <option value="formation">Formation au permis</option>
            <option value="recuperer">Récupérer mon permis</option>
          </select>

          <template v-if="motifInscription === 'recuperer'">
            <p class="motif-redirect">
              monpermis.fr est un site de formation au permis de conduire.<br />
              Pour récupérer votre permis, rendez-vous sur
              <a href="https://permisdeconduire.ants.gouv.fr" target="_blank" rel="noopener">permisdeconduire.ants.gouv.fr</a>
            </p>
          </template>

          <template v-else>
            <input type="text" placeholder="Nom élève" v-model="form.nom" required />
            <input type="text" placeholder="Prénom élève" v-model="form.pnom" required />
            <input type="email" placeholder="Email" v-model="form.email" required />
            <input type="text" placeholder="Téléphone" v-model="form.tel" required />
            <div class="password-wrapper">
              <input
                :type="showMobileInscPassword ? 'text' : 'password'"
                placeholder="Mot de passe"
                v-model="form.password"
                required
              />
              <button type="button" class="toggle-password" @click="showMobileInscPassword = !showMobileInscPassword">
                <i :class="showMobileInscPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              </button>
            </div>
            <div class="password-wrapper">
              <input
                :type="showMobileInscPasswordConfirm ? 'text' : 'password'"
                placeholder="Confirmer le mot de passe"
                v-model="form.passwordTest"
                required
              />
              <button type="button" class="toggle-password" @click="showMobileInscPasswordConfirm = !showMobileInscPasswordConfirm">
                <i :class="showMobileInscPasswordConfirm ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              </button>
            </div>
            <select name="agence" id="agence" v-model="form.choixAgence" required>
              <option value="" disabled selected>
                Veuillez choisir votre agence
              </option>
              <option
                v-for="(agence, index) in agences"
                :value="agence.id"
                :key="index"
              >
                {{ agence.nom }}
              </option>
            </select>
            <button class="btn-action" v-if="isWorking === false">
              Inscription
            </button>
            <button v-else disabled>
              <span><i class="fa fa-spinner fa-spin"></i> Inscription </span>
            </button>
            <b-alert variant="danger" v-if="error != ''" show>{{
              error
            }}</b-alert>
          </template>
        </form>
      </div>

      <!-- CONNEXION (mobile) -->
      <div class="login" v-if="!showSignInMobile">
        <form @submit.prevent="login">
          <h1>Connexion</h1>
          <input type="email" placeholder="Email" v-model="email" />
          <div class="password-wrapper">
            <input
              :type="showMobileLoginPassword ? 'text' : 'password'"
              placeholder="Mot de passe"
              v-model="password"
            />
            <button type="button" class="toggle-password" @click="showMobileLoginPassword = !showMobileLoginPassword">
              <i :class="showMobileLoginPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
            </button>
          </div>
          <a @click="this.displayMdpForm = true">Mot de passe oublié ?</a>
          <button v-if="isWorking === false" class="btn-action">
            Connexion
          </button>
          <button v-else disabled>
            <span><i class="fa fa-spinner fa-spin"></i> CONNEXION </span>
          </button>
          <b-alert variant="danger" v-if="error != ''" show>{{
            error
          }}</b-alert>
        </form>
      </div>
    </div>
    </template>

    <Dialog
      :header="`Réinitialiser votre mot de passe !`"
      v-model:visible="this.displayMdpForm"
      :style="{ width: '50vw' }"
    >
      <div>
        <div class="field mt-5">
          <div class="control">
            <input
              class="form-control"
              type="text"
              required
              id="mail"
              name="mail"
              v-model="oublieForm.mail"
              placeholder=" "
            />
            <label class="labelForm">Mail</label>
          </div>
        </div>

        <center>
          <Button class="btnViolet mt-5" @click="checkIfUserExist()"
            >Suivant</Button
          >
        </center>
      </div>
    </Dialog>
  </div>
</template>
<script>
import jwt_decode from "jwt-decode";
import { useToast } from "primevue/usetoast";

export default {
  data() {
    return {
      visibilityMdp: null,
      oublieForm: {
        mail: "",
      },
      isWorking: false,
      displayMdpForm: false,
      toast: useToast(),
      email: "",
      password: "",
      error: "",
      code: "",
      showLog: true,
      motifInscription: "",
      form: { 
        pnom: "",
        nom: "",
        tel: "",
        password: "",
        passwordTest: "",
        choixAgence: "",
      },
      agences: [],
      showSignInMobile: false,
      // Visibilité des mots de passe
      showLoginPassword: false,
      showInscPassword: false,
      showInscPasswordConfirm: false,
      showMobileLoginPassword: false,
      showMobileInscPassword: false,
      showMobileInscPasswordConfirm: false,
      // Passer à true pour restreindre l'accès à toute la page (sauf code d'accès)
      blockAccess: false,
      accessCode: "",
    };
  },

  computed: {
    pageLocked() {
      return this.blockAccess && this.accessCode !== "5408b";
    },
  },

  mounted() {
    this.getAgences();
  },

  methods: {
    showSignIn() {
      document
        .getElementById("container")
        .classList.remove("right-panel-active");
    },

    showSignUp() {
      document.getElementById("container").classList.add("right-panel-active");
    },

    login(event) {
      event.preventDefault();
      this.isWorking = true;
      window.api
        .post("/login_check", {
          username: this.email,
          password: this.password,
        })
        .then((response) => {
          this.error = "";
          let user = jwt_decode(response.data.token);
          this.$store.commit("setUser", user);
          this.$store.commit("setToken", response.data.token);
          this.$router.push("/home");
          this.isWorking = false;
        })
        .catch(() => {
          this.error = "Mot de passe ou mail incorrect";
          this.isWorking = false;
        });
    },

    async checkIfUserExist() {
      if (this.oublieForm.mail != "") {
        window.api
          .post("/checkIfUserExist", {
            email: this.oublieForm.mail,
          })
          .then((res) => {
            this.$emit("completed", res.data);
            this.toast.add({
              severity: "success",
              summary: "Email envoyé",
              detail: "Un email de réinitialisation de mot de passe a bien été envoyé à l'élève",
              life: 3000,
            });
          })
          .catch((error) => {
            this.toast.add({
              severity: "error",
              summary: "Erreur",
              detail: "Une erreur est survenue, l'email n'a pas pu être envoyé",
              life: 3000,
            });
            console.log(error);
          });
      }
    },

    getAgences() {
      window.api
        .get("/agences")
        .then((response) => {
          // Temporaire : seule l'agence CER Garibaldi est proposée à l'inscription
          this.agences = response.data["hydra:member"].filter((a) =>
            a.nom.toUpperCase().includes("GARIBALDI")
          );
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    },

    inscription(event) {
      event.preventDefault();
      this.isWorking = true;

      if (this.form.tel.length > 10) {
        this.error = "Veuillez saisir un numéro de téléhone inférieur à 10";
      } else if (this.form.password != this.form.passwordTest) {
        this.error =
          "Veuillez saisir les mêmes mots de passe dans les champs correspondants";
      } else {
          this.error = "";
          if (this.form.choixAgence == "noAgence") {
            window.api
              .post("/signup", {
                email: this.form.email,
                password: this.form.password,
                prenom: this.form.pnom,
                nom: this.form.nom,
                telephone: this.form.tel,
                active: 1,
              })
              .then(() => {
                this.loginAfterInsc();
              }).catch((error) => {
                this.isWorking = false;
                console.log(error);
              });
          } else {
              window.api
                .post("/signup", {
                  email: this.form.email,
                  password: this.form.password,
                  prenom: this.form.pnom,
                  nom: this.form.nom,
                  telephone: this.form.tel,
                  active: 1,
                  agence: this.form.choixAgence,
                })
                .then((response) => {
                  if (response.data.message !== undefined) {
                    this.error = response.data.message;
                    this.isWorking = false;
                  } else {
                    this.loginAfterInsc();
                  }
                })
                .catch((error) => {
                  this.isWorking = false;
                  console.log(error);
                });
            }
        }
    },

    loginAfterInsc() {
      window.api
        .post("/login_check", {
          username: this.form.email,
          password: this.form.password,
        })
        .then((response) => {
          this.error = "";
          let user = jwt_decode(response.data.token);
          this.$store.commit("setUser", user);
          this.$store.commit("setToken", response.data.token);

          window.api
            .post(
              "/sendMail",
              {
                type: "inscription",
                email: this.form.email,
              },
              {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token,
                },
              },
            )
            .then(() => {
              this.$router.push("/home");
              this.isWorking = false;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {
          this.isWorking = false;
          this.error = "Mot de passe ou mail incorrect";
        });
    },
  },
};
</script>
<style scoped>
div.log {
  width: 100vw;
  height: 100vh;
  background-image: url("../assets/images/Fond_ordinateur.png");
  background-size: cover;
  background-color: #F4F6F9;
}

div.log div.header-log {
  display: flex;
  border-bottom: 1px solid #E2E8F0;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  background-color: white;
  margin-bottom: 5rem;
}

div.log div.header-log span {
  color: #6899f5;
}

div.log div.header-log img {
  width: 60px;
  height: 60px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.access-gate {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4rem 20px;
}

.access-gate-card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow:
    0 14px 28px rgba(0, 0, 0, 0.25),
    0 10px 10px rgba(0, 0, 0, 0.22);
  padding: 40px 50px;
  text-align: center;
  max-width: 420px;
  width: 100%;
}

.access-gate-logo {
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
}

h1 {
  font-weight: bold;
  margin: 0;
}

h2 {
  text-align: center;
}

p {
  font-size: 14px;
  font-weight: 100;
  line-height: 20px;
  letter-spacing: 0.5px;
  margin: 20px 0 30px;
}

a {
  color: #333;
  font-size: 14px;
  text-decoration: none;
  margin: 15px 0;
}

button {
  border-radius: 20px;
  border: 1px solid #6899f5;
  background-color: #6899f5;
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  padding: 12px 45px;
  letter-spacing: 1px;
  text-transform: uppercase;
  transition: transform 80ms ease-in;
}

button.btn-action:active {
  transform: scale(0.95);
}

button:focus {
  outline: none;
}

button.ghost {
  background-color: transparent;
  border-color: #ffffff;
}

/* Bouton œil mot de passe */
.password-wrapper {
  position: relative;
  width: 100%;
  margin: 8px 0;
}

.password-wrapper input {
  margin: 0;
  width: 100%;
  padding-right: 42px;
}

.toggle-password {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  padding: 0;
  color: #888;
  font-size: 14px;
  cursor: pointer;
  letter-spacing: 0;
  text-transform: none;
  font-weight: normal;
}

.toggle-password:hover {
  color: #6899f5;
}

form {
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 50px;
  height: 100%;
  text-align: center;
}

.motif-redirect {
  font-size: 13px;
  line-height: 1.6;
  color: #555;
  margin: 20px 0;
}

.motif-redirect a {
  color: #6899f5;
  font-weight: bold;
  text-decoration: underline;
}

.insc-locked {
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 50px;
  height: 100%;
  text-align: center;
}

input {
  background-color: #eee;
  border: none;
  padding: 12px 15px;
  margin: 8px 0;
  width: 100%;
}

select {
  background-color: #eee;
  border: none;
  padding: 12px 15px;
  margin: 8px 0;
  width: 100%;
}

.container {
  background-color: #fff;
  border-radius: 10px;
  box-shadow:
    0 14px 28px rgba(0, 0, 0, 0.25),
    0 10px 10px rgba(0, 0, 0, 0.22);
  position: relative;
  overflow: hidden;
  width: 50%;
  max-width: 100%;
  min-height: 700px;
}

.mobile-button {
  display: none;
}

.form-container {
  position: absolute;
  top: 0;
  height: 100%;
  transition: all 0.6s ease-in-out;
}

.sign-in-container {
  left: 0;
  width: 50%;
  z-index: 2;
}

.container.right-panel-active .sign-in-container {
  transform: translateX(100%);
}

.sign-up-container {
  left: 0;
  width: 50%;
  opacity: 0;
  z-index: 1;
}

.container.right-panel-active .sign-up-container {
  transform: translateX(100%);
  opacity: 1;
  z-index: 5;
  animation: show 0.6s;
}

@keyframes show {
  0%,
  49.99% {
    opacity: 0;
    z-index: 1;
  }

  50%,
  100% {
    opacity: 1;
    z-index: 5;
  }
}

.overlay-container {
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  overflow: hidden;
  transition: transform 0.6s ease-in-out;
  z-index: 100;
}

.container.right-panel-active .overlay-container {
  transform: translateX(-100%);
}

.overlay {
  background: #6899f5;
  background: -webkit-linear-gradient(to right, #684eff, #6899f5);
  background: linear-gradient(to right, #684eff, #6899f5);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 0 0;
  color: #ffffff;
  position: relative;
  left: -100%;
  height: 100%;
  width: 200%;
  transform: translateX(0);
  transition: transform 0.6s ease-in-out;
}

.container.right-panel-active .overlay {
  transform: translateX(50%);
}

.overlay-panel {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 40px;
  text-align: center;
  top: 0;
  height: 100%;
  width: 50%;
  transform: translateX(0);
  transition: transform 0.6s ease-in-out;
}

.overlay-left {
  transform: translateX(-20%);
}

.container.right-panel-active .overlay-left {
  transform: translateX(0);
}

.overlay-right {
  right: 0;
  transform: translateX(0);
}

.container.right-panel-active .overlay-right {
  transform: translateX(20%);
}

.container-mobile {
  display: none;
}

@media (max-width: 1000px) {
  div.container {
    display: none;
  }

  .container-mobile {
    display: block;
  }

  div.log div.header-log img {
    width: 90px;
    height: 90px;
  }

  .mobile-button {
    display: inline-block;
  }

  div.container-mobile {
    width: 95%;
    margin: auto;
    margin-top: 3rem;
    background-color: #fff;
    border-radius: 10px;
    box-shadow:
      0 14px 28px rgba(0, 0, 0, 0.25),
      0 10px 10px rgba(0, 0, 0, 0.22);
  }

  button {
    margin-bottom: 1em;
  }
}
</style>